import React, { useRef } from 'react';
import Header from '../Header/Header';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import success from '../../audios/success.m4r';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';


toast.configure()

const Contact = () => {
    const form = useRef();
    const [isLoading, setIsLoading] = useState(false)


    const sendEmail = (e) => {
        e.preventDefault();
        setIsLoading(true);
        emailjs.sendForm('service_6jhmxlc', 'template_1d5ukbk', form.current, 'user_YQ4bJ43vmQjJnQbagsaB0')
            .then((result) => {
                const audio = new Audio();
                audio.src = success;
                audio.play();
                toast.success("Email Sent Successfully")
                setIsLoading(false);
                e.target.reset();
            }, (error) => {
                console.log(error.text);
            });

    };



    return (
        <div style={{ backgroundColor: '#141c3a', height: "100vh" }}>
            <div>
                <Header></Header>
                <div className="my-5 text-white">
                    <h2 className="fw-bold">Ready to get started ?</h2>
                </div>
                <form ref={form} onSubmit={sendEmail} className="col-11 col-md-10 col-xl-6 mx-auto">
                    <div className="form-floating mb-3">
                        <input type="text" className="form-control" id="floatingName" placeholder="name@example.com"
                            required name="name" />
                        <label htmlFor="floatingName">Your Name</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input name="email" type="email" className="form-control" id="floatingEmail" placeholder="Email" required />
                        <label htmlFor="floatingEmail">Your Email</label>
                    </div>
                    <div className="form-floating mb-3">
                        <input type="text" className="form-control" id="floatingSubject" placeholder="name@example.com"
                            required name="subject" />
                        <label htmlFor="floatingSubject">Subject</label>
                    </div>

                    <div className="form-floating mb-2">
                        <textarea style={{ height: '200px' }} type="text" className="form-control" id="floatingMessage" placeholder="Message" required name="message" />
                        <label htmlFor="floatingMessage">Message</label>
                    </div>
                    {
                        !isLoading
                            ?
                            <button type="submit" className="btn btn-outline-light btn-lg mt-5 rounded-pill">Send Message <FontAwesomeIcon icon={faPaperPlane} /></button>
                            :
                            <button type="submit" className="btn btn-light btn-lg mt-5 rounded-pill" disabled><i className="fa fa-spinner fa-spin"></i> Sending</button>
                    }
                </form>
            </div>
        </div>
    );
};

export default Contact;